import Vue from 'vue'
import VueI18n from 'vue-i18n'

import '../shared/vue_error_handling';

import App from './components/app.vue'

document.addEventListener('DOMContentLoaded', () => {
  const elementId = 'course-presentation-lesson-show';
  const data = JSON.parse(document.getElementById(elementId).getAttribute('data'));

  Vue.use(VueI18n);

  let messages = {};
  messages[data.locale] = data.messages;

  const props = data.props

  const i18n = new VueI18n({
    locale: data.locale,
    messages
  });

  new Vue({
    i18n,
    render: h => h(App, { props })
  }).$mount(`#${elementId}`);
});
